import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-43">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/jCEr5u5p9dq3b6z12UVaph/image.png")'
    }} data-id="element-44" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60" data-id="element-45" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center mt-16" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-47">
          <h1 className="text-5xl md:text-7xl lg:text-8xl text-white font-serif mb-6 leading-tight" data-id="element-48">
            Modern Fix
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-49">
          <h2 className="text-xl md:text-3xl text-gray-200 font-light mb-8 tracking-wide" data-id="element-50">
            Residential Remodeling in Los Angeles
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-51">
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-52">
            We specialize in high-quality home remodeling, including kitchen,
            bathroom, and interior renovations. Modern Fix helps homeowners
            transform their spaces with clean design, precision work, and
            reliable service.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-53">
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-brand-accent text-white font-medium hover:bg-brand-dark transition-colors duration-300 text-center" data-id="element-54">
            Contact Us
          </a>
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-white text-brand-dark font-medium hover:bg-gray-100 transition-colors duration-300 text-center" data-id="element-55">
            Call Now
          </a>
        </motion.div>
      </div>
    </section>;
}